import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-报表管理",
  "use": "icon-报表管理-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-报表管理\">\n<rect x=\"13\" y=\"16.2\" width=\"134\" height=\"127.6\" rx=\"11\" stroke-width=\"10\" />\n<rect x=\"13\" y=\"52.2\" width=\"134\" height=\"91.6\" rx=\"11\" stroke-width=\"10\" />\n<rect x=\"49.6\" y=\"87.6\" width=\"4\" height=\"37.6\" rx=\"2\" stroke-width=\"4\" />\n<rect x=\"78.4\" y=\"78.8\" width=\"4\" height=\"46.4\" rx=\"2\" stroke-width=\"4\" />\n<rect x=\"78.0001\" y=\"19.6\" width=\"4\" height=\"27.2\" rx=\"2\" stroke-width=\"4\" />\n<rect x=\"107.2\" y=\"101.2\" width=\"4\" height=\"24\" rx=\"2\" stroke-width=\"4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/报表管理.svg
// module id = GmIW
// module chunks = 26